<!-- EntityForm.vue -->
<template>
  <span>
    <Button variant="primary" size="3_5" @click="activate">
      <slot></slot>
    </Button>
    <b-modal
      v-model="active"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Create New {{ label }}</p>
          <button
            type="button"
            class="delete"
            v-on:click="close"/>
        </header>
        <div class="modal-card-body">
          <form method="POST" :id="formId" :action="formAction" ref="form" v-on:submit.prevent="submitForm">
            <div class="field">
              <label class="label" for="id_first_name">First name:</label>
              <div class="control is-expanded">
                <input class="input is-medium" type="text" name="first_name" maxlength="30" id="id_first_name">
                <div class="error" v-if="errors.first_name" v-for="error in errors.first_name">
                  <p class="help is-danger">{{ error.message }}</p>
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label" for="id_last_name">Last name:</label>
              <div class="control is-expanded">
                <input class="input is-medium" type="text" name="last_name" maxlength="150" id="id_last_name">
                <div class="error" v-if="errors.last_name" v-for="error in errors.last_name">
                  <p class="help is-danger">{{ error.message }}</p>
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label" for="id_entity_type">Entity Type:</label>
              <div class="control">
                <div class="select is-medium is-fullwidth">
                  <select id="id_entity_type" name="entity_type" v-model="entityType">
                    <option value="prospect">Prospect</option>
                    <option value="client">Client</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-card-foot">
          <input
            type="submit"
            :form="formId"
            v-bind:value="buttonText"
            class="button is-primary is-right"
            ref="submitButton"
          />
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { Button } from '@stakeui';

  export default {
    props: {
      callback: Function,
      buttonClass: String,
      relationshipType: {
        type: String,
        required: true,
        validator: value => ['Parent', 'Child'].includes(value)
      },
      label: {
        type: String,
        required: true,
        validator: value => ['Parent', 'Child', 'Group', 'Member'].includes(value)
      },
      entityExternalId: {
        type: String,
        required: true,
      },
    },
    components: {
      Button,
    },
    data() {
      return {
        active: false,
        buttonText: 'Create Entity',
        errors: {},
        entityType: 'prospect',
        formId: `entity-form-${this._uid}`
      }
    },
    computed: {
      formAction() {
        return this.entityType === 'prospect' 
          ? '/advisordashboard/prospect-create/'
          : '/advisordashboard/shareowner-create/';
      }
    },
    methods: {
      reset() {
        this.buttonText = 'Create Entity';
        this.entityType = 'prospect';
        ['first_name', 'last_name'].forEach(name => this.clearInput(name));
      },
      clearInput(name) {
        const input = document.getElementById('id_' + name);
        if(input) input.value = '';
      },
      close() {
        this.active = false;
      },
      activate() {
        this.active = true;
      },
      async submitForm(evt) {
        this.buttonText = 'Saving...';
        const form = this.$refs.form;
        const formData = new FormData(form);

        formData.append('relationship_type', this.relationshipType);
        formData.append('related_entity_id', this.entityExternalId);

        const postData = new URLSearchParams(formData);

        try {
          const resp = await fetch(this.formAction, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-CSRFToken': this.$root.$data.csrfToken,
            },
            body: postData,
          });

          if (resp.ok) {
            const data = await resp.json();
            this.callback({
              ...data,
              ...Object.fromEntries(formData),
              entityType: this.entityType,
              relationshipType: this.relationshipType.toLowerCase(),
            });
            this.close();
            this.reset();
          } else {
            const data = await resp.json();
            this.buttonText = 'Create Entity';
            this.errors = data.errors;
          }
        } catch (error) {
          console.error('Error creating entity:', error);
          this.buttonText = 'Create Entity';
          this.errors = { general: [{ message: 'Failed to create entity' }] };
        }
      }
    }
  }
</script>